import React from "react";

const stats = [
  {
    metric: "95%+",
    label: "Data accuracy ensures high-quality outreach.",
  },
  {
    metric: "50M",
    label: "Verified contacts in our database.",
  },
  {
    metric: "2X",
    label: "Growth in ROI for 70% of our customers within the first year.",
  },
  {
    metric: "99.9%",
    label: "Uptime ensures your tools are always ready to work when you are.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-white" id="why-choose-beyondleadz">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            BeyondLeadz Advantage
          </span>
          <h2 className="tw-text-3xl sm:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
            Why Choose BeyondLeadz?
          </h2>
          <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-max-w-3xl tw-mx-auto">
            BeyondLeadz is your ultimate partner in sales and marketing automation, combining precision, speed, and simplicity in one powerful platform. With AI-driven insights, 95%+ data accuracy, and seamless integration with your favorite tools, BeyondLeadz empowers your team to work smarter, not harder.
          </p>
        </div>

        {/* Responsive Grid */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-stretch tw-mt-12">
          
          {/* Left Side: Stats Grid (4 cards) */}
          <div className="lg:tw-col-span-8 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-8">
            {stats.map((item, idx) => (
              <div
                key={idx}
                className="tw-group tw-bg-slate-50/50 hover:tw-bg-white tw-border tw-border-solid tw-border-slate-100 hover:tw-border-indigo-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-center tw-flex tw-flex-col tw-justify-center"
              >
                <div className="tw-text-4xl sm:tw-text-5xl tw-font-extrabold tw-text-[#5D44FF] tw-mb-3">
                  {item.metric}
                </div>
                <div className="tw-text-sm sm:tw-text-base tw-text-slate-600 tw-font-medium tw-leading-relaxed">
                  {item.label}
                </div>
              </div>
            ))}
          </div>

          {/* Right Side: Big Brand Trust Card */}
          <div className="lg:tw-col-span-4 tw-flex">
            <div className="tw-w-full tw-bg-gradient-to-br tw-from-[#5D44FF] tw-to-indigo-700 tw-text-white tw-rounded-3xl tw-p-10 tw-text-center tw-shadow-xl tw-shadow-indigo-500/25 tw-flex tw-flex-col tw-justify-center tw-items-center">
              <div className="tw-text-5xl tw-font-extrabold tw-mb-4">
                10,000+
              </div>
              <div className="tw-text-xl sm:tw-text-2xl tw-font-bold tw-mb-3 tw-leading-snug">
                Businesses Worldwide
              </div>
              <p className="tw-text-indigo-100 tw-text-sm sm:tw-text-base tw-leading-relaxed tw-m-0">
                Trust BeyondLeadz to drive their sales pipelines, verify customer contacts, and scale business-to-business growth.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
